<div class="m-4 flex h-[720px] flex-col rounded-lg bg-white p-5 pb-2.5 shadow-md">
  <div class="gradient m-[10px] h-[20px] w-[25%]" />
  <div class="gradient my-8 h-[130px] w-[130px] self-center" />
  <div class="gradient my-0.5 h-5 w-full items-center" />
  <div class="gradient my-0.5 h-5 w-full items-center" />
  <div class="gradient mt-5 mb-0.5 h-8 w-[66%] items-center" />
  <div class="gradient my-0.5 h-[20px] w-[35%]" />
  <div class="gradient mt-0.5 mb-5 h-[10px] w-[20%]" />
  <div class="flex">
    <div class="gradient my-0.5 mr-[10px] h-3 w-[10%]" />
    <div class="gradient my-0.5 h-3 w-[60%]" />
  </div>
  <div class="flex">
    <div class="gradient my-0.5 mr-[10px] h-3 w-[10%]" />
    <div class="gradient my-0.5 h-3 w-[60%]" />
  </div>
  <div class="flex">
    <div class="gradient my-0.5 mr-[10px] h-3 w-[10%]" />
    <div class="gradient my-0.5 h-3 w-[60%]" />
  </div>
  <div class="flex">
    <div class="gradient my-2.5 mr-[10px] h-8 w-[50%]" />
    <div class="gradient my-2.5 h-8 w-[50%]" />
  </div>
  <div class="gradient my-2.5 h-5 w-full items-center" />
  <div class="gradient my-2.5 h-5 w-full items-center" />
  <div class="gradient my-2.5 h-5 w-full items-center" />
  <div class="gradient my-2.5 h-5 w-full items-center" />
</div>

<style>
  .gradient {
    min-height: 10px;
    min-width: 100px;
    animation-duration: 1.8s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: placeHolderShimmer;
    animation-timing-function: linear;
    background: #f6f7f8;
    background: linear-gradient(to right, #fafafa 8%, #f4f4f4 38%, #fafafa 54%);
    background-size: 1000px 640px;
    position: relative;
  }

  @keyframes placeHolderShimmer {
    0% {
      background-position: -468px 0;
    }
    100% {
      background-position: 468px 0;
    }
  }
</style>
